import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Tabs, Card, Alert, Divider } from 'antd'
import { req_single_cms_school_student, req_single_cms_learnmap_yearplan, req_single_cms_learnmap_talent_tab, req_single_cms_learnmap_talent_course_map } from '../../api'
import './coursemap-student-course-learnmap.css'

const { TabPane } = Tabs
class CoursemapStudentCourseLearnmap extends Component {
    // 基礎通用參數 //////////////////////////////////////////////  
    state = {
        items: [],
        deviceWidth: 0,
        loading: false,
        detailsloading: false,
        defaultKey: null,
        talents: []
    }

    componentDidMount() {
        window.addEventListener('resize', this.resize.bind(this))
        this.resize()
        this.api_init_items()
    }

    // componentWillUnmount() {
    //     window.removeEventListener("resize", this.resize.bind(this))
    // }

    resize() {
        this.setState({ deviceWidth: window.innerWidth });
    }

    // 遠端數據處理 //////////////////////////////////////////////
    api_init_items = async () => {
        const { userCode, token } = this.props.user
        this.setState({ loading: true, items: [] })
        const result = await req_single_cms_school_student(userCode, token)
        if (result) {
            const yearplan = await req_single_cms_learnmap_yearplan(result, token)
            //console.log(yearplan)
            if (yearplan) {
                const tab = await req_single_cms_learnmap_talent_tab(userCode, token)
                if (tab) {
                    if (tab.total > 0) {
                        const talents = tab.data
                        const defaultKey = talents[0].nidTalent
                        this.setState({ talents, defaultKey })
                        this.tab_change(defaultKey)
                        this.setState({ loading: false })
                    }
                } else {
                    this.setState({ loading: false })
                }
            } else {
                this.setState({ loading: false })
            }
        } else {
            this.setState({ loading: false })
        }

    }

    // 數據配置處理 //////////////////////////////////////////////

    set_label_text = (key, value) => {
        let data = ''
        switch (key) {
            case 'GRADE':
                switch (value) {
                    case '1':
                        data = '一年級'
                        break
                    case '2':
                        data = '二年級'
                        break
                    case '3':
                        data = '三年級'
                        break
                    case '4':
                        data = '四年級'
                        break
                    case '5':
                        data = '五年級'
                        break
                    case '6':
                        data = '六年級'
                        break
                    case '7':
                        data = '七年級'
                        break
                    default:
                }
                break;
            case 'SEMESTER':
                switch (value) {
                    case '1':
                        data = '上學期'
                        break
                    case '2':
                        data = '下學期'
                        break
                    default:
                }
                break
            default:

        }
        return data

    }

    groupBy = (rows, key) => {
        return rows.reduce(function (group, row) {
            (group[row[key]] = group[row[key]] || []).push(row);
            return group;
        }, {});
    }

    listItems = (items, semester) => {
        // console.log('LIST', items)
        return items.reduce((item_pre, item) => {
            if (item.studentSemester === semester) {
                (item.courseTalentTag === 'M') ?
                    item_pre.push(<button key={item.courseCode} className="btn btn-master" style={{ marginLeft: '3px', marginBottom: '3px' }}>{item.courseTwName}</button>) :
                    item_pre.push(<button key={item.courseCode} className="btn btn-minor" style={{ marginLeft: '3px', marginBottom: '3px' }}>{item.courseTwName}</button>)
            }
            return item_pre
        }, [])
    }

    // 介面互動處理 //////////////////////////////////////////////

    tab_change = async (key) => {
        const { talents } = this.state
        const { token } = this.props.user
        const talent = talents.find(x => x.nidTalent === key)
        //console.log('talent', talent)
        const tagret = {
            gidLearnMapMeta: talent.gidLearnMapMeta,
            nidLearnMapMeta: talent.nidLearnMapMeta,
            gidTalent: talent.gidTalent,
            nidTalent: talent.nidTalent
        }
        this.setState({ items: [], detailsloading: true })
        const result = await req_single_cms_learnmap_talent_course_map(tagret, token)
        if (result) {
            if (result.total > 0) {
                let rows = result.data[0].courseMapItems
                const courseTotal = rows.length
                let talentCourseSumValue = 0
                let talentCourseAvgValue = 0
                rows.forEach(item => {
                    talentCourseSumValue = talentCourseSumValue + item.courseTalentAllValue
                })
                talentCourseAvgValue = talentCourseSumValue / courseTotal
                rows.forEach(function (item) {
                    if (item.courseTalentAllValue > talentCourseAvgValue) {
                        item.courseTalentTag = 'M';
                    } else {
                        item.courseTalentTag = 'A';
                    };
                });
                const items = this.groupBy(rows, 'studentGrade')
                this.setState({ items })
                this.setState({ detailsloading: false })
                console.log('items_course', items)
            } else {
                this.setState({ detailsloading: false })
            }
        } else {
            this.setState({ detailsloading: false })
        }

    }

    /////////////////////////////////////////////////////////////    
    render() {
        const { loading, detailsloading, defaultKey, talents, items } = this.state
        const tabPanes = talents.length > 0 ? talents.map((row, idx) => <TabPane tab={row.talentTwName} key={row.nidTalent}>
            <Alert
                key={idx}
                description={row.talentDescription}
                type="success"
                showIcon
            />
            <div className="text-center">
                <button key={idx} className="btn btn-master" style={{ margin: '3px' }}>重要</button>
                <button key={idx} className="btn btn-minor" style={{ margin: '3px' }}>輔助</button>
            </div>
        </TabPane>
        ) : ''
        const htmlItems = talents.length > 0 ? (<>
            <Tabs defaultActiveKey={defaultKey} onChange={this.tab_change}>
                {tabPanes}
            </Tabs>
            <Card>
                {detailsloading ? (<div className='text-center'>
                    <p />
                    <button className="btn " type="button" disabled>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ marginRight: '4px' }}></span>
                        Loading...
                    </button>
                </div>) : (<>
                    <Tabs defaultActiveKey="0" >
                        {Object.keys(items).map((item, i) => (
                            <TabPane tab={this.set_label_text('GRADE', item)} key={item}>
                                <Divider orientation="center" plain>上學期</Divider>
                                {this.listItems(items[item], '1')}
                                <Divider orientation="center" plain>下學期</Divider>
                                {this.listItems(items[item], '2')}
                            </TabPane>

                        ))}
                    </Tabs>
                </>)}
            </Card>
        </>) : (<Alert
            message="無相關資訊(此功能僅適用日四技查詢)"
            type="warning"
            closable
        />)

        return (
            <> {loading ? (<div className='text-center'>
                <p />
                <button className="btn " type="button" disabled>
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ marginRight: '4px' }}></span>
                    Loading...
                </button>
            </div>) : (<>
                {htmlItems}
            </>)}</>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(CoursemapStudentCourseLearnmap)